<div class="service-collapsible">
  <div class="header">

    <a [routerLink]="link" class="title" [title]="'Abrir ' + title">{{ title | uppercase }}</a>

    <div class="toggle" *ngIf="hasMoreThanThreeItems" (click)="toggleExpand()">
      <span class="expand-text">{{ isExpanded ? 'Recolher' : 'Expandir' }}</span>
      <div class="arrow" [class.rotate]="isExpanded">
        <app-lucide-icon [iconName]="'chevron-down'"></app-lucide-icon>
      </div>
    </div>
  </div>

  <div class="content">
    <div class="services-container">
      <ng-container *ngFor="let item of visibleItems">
        <div class="service-item">
          <app-box-link
            [title]="item.nome"
            [iconName]="item.icone || 'layout-grid'"
            [description]="item.descricao"
            (clickEvent)="handleItemClick(item.url)">
          </app-box-link>
        </div>
      </ng-container>
    </div>
  </div>
</div>
